import Vue from "vue";

Vue.filter("toCurrency", (value) => {
    if (typeof value !== "number") {
        return value;
    }

    var formatter = new Intl.NumberFormat(["ban", "id"], {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
    });

    return formatter.format(value);
});



// WEBPACK FOOTER //
// ./src/filters.js